
const defaultWidth = 0.1

function Stroke ({points, width = defaultWidth, widthEnvelope = false, pointyEnds = false}) {

    this.width = width
    this.widthEnvelope = widthEnvelope

    this.envelope = polygonEnvelope({
        points,
        width,
        widthEnvelope,
        pointyEnds
    })

}


function polygonEnvelope ({points, width, widthEnvelope, pointyEnds}) { //, noise

    let firstPoint = points[0]
    let lastPoint  = points[points.length - 1]

    let semiWidth = width / 2


    let leftPath  = [firstPoint]
    let rightPath = [firstPoint]

    let startIndex = pointyEnds ? 1 : 0
    let endIndex   = points.length - startIndex


    //let noiseVariation = random.between(0, 10)

    for (let i = startIndex; i < endIndex; i++) {

        let point         = points[i]
        let previousPoint = points[i - 1]
        let nextPoint     = points[i + 1]

        let angle = bisectingAngle(point, previousPoint, nextPoint)

        let delta = semiWidth

        if (widthEnvelope) {
            let t = i / points.length
            delta *= widthEnvelope({ratio: t, point})
        }

        /*
        if (noise) {
            delta *= 1 + noise * perlin11(i * 0.5, noiseVariation)
        }
        */

        addEnvelopePoint({leftPath, rightPath, point, delta, angle})

    }

    if (pointyEnds) {
        return [...leftPath, lastPoint, ...rightPath.toReversed()]
    } else {
        return [...leftPath, ...rightPath.toReversed()]
    }



}


function addEnvelopePoint ({leftPath, rightPath, point, delta, angle}) {

    let deltaX = delta * Math.cos(angle)
    let deltaY = delta * Math.sin(angle)

    let {x, y} = point

    leftPath.push({
        x: x + deltaX,
        y: y + deltaY
    })

    rightPath.push({
        x: x - deltaX,
        y: y - deltaY
    })

}


function bisectingAngle ({x, y}, previousPoint, nextPoint) {

    let angleWithPrevious

    if (previousPoint) {
        angleWithPrevious = Math.atan2(
            y - previousPoint.y,
            x - previousPoint.x
        )
    }

    if (!nextPoint) {
        return angleWithPrevious - Math.PI / 2
    }

    let angleWithNext = Math.atan2(
        y - nextPoint.y,
        x - nextPoint.x
    )

    if (!previousPoint) {
        return angleWithNext + Math.PI / 2
    }

    let middleAngle = (angleWithPrevious + angleWithNext) / 2

    if (middleAngle < angleWithNext) {
        middleAngle += Math.PI
    }

    return middleAngle

}


export default Stroke

